import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import InternalTraining from "../views/internal-training/index.vue";
import FaceClassCategory from "../views/face-class-category/index.vue";
import FaceClassManage from "../views/face-class-manage/index.vue";
import InformationManage from '../views/informationManage/index.vue';
import SwiperManage from '../views/swiperManage/index.vue';
import ApplicationFor from '../views/applicationFor/index.vue';
import MessageBoard from '../views/messageBoard/index.vue';
import StudentsManage from '../views/studentsManage/index.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'child',
    component: Home
  },
  {
    path: '/teacherInfo',
    name: 'child',
    component: () => import("@/views/model/teacherInfo.vue")
  },
  {
    path: '/cooperator',
    name: 'child',
    component: () => import("@/views/model/cooperator.vue")
  },
  {
    path: '/organization',
    name: 'child',
    component: () => import("@/views/model/organization.vue")
  },
  {
    path: '/InternalTraining',
    name: 'InternalTraining',
    component: InternalTraining
  },
  {
    path: '/FaceClassCategory',
    name: 'FaceClassCategory',
    component: FaceClassCategory
  },
  {
    path: '/FaceClassManage',
    name: 'FaceClassManage',
    component: FaceClassManage
  },
  {

    path: '/certificate',
    name: 'child',
    component: () => import("@/views/model/certificate.vue")
  },
  {
    path: '/testPlan',
    name: 'child',
    component: () => import("@/views/model/testPlan.vue")
  },
  {
    path: '/talentService',
    name: 'child',
    component: () => import("@/views/model/talentService.vue")
  },
  {
    path: '/careerMatrix',
    name: 'CareerMatrix',
    component: () => import("@/views/model/careerMatrix.vue")
  },
  {
    path: '/aboutUs',
    name: 'child',
    component: () => import("@/views/model/aboutUs.vue")
  },
  {
    path: '/informationManage',
    name: 'InformationManage',
    component: InformationManage
  },
  {
    path: '/authoritativeReleaseManage',
    name: 'AuthoritativeReleaseManage',
    component: () => import('@/views/authoritativeReleaseManage/index.vue')
  },
  {
    path: '/trainingManage',
    name: 'TrainingManage',
    component: () => import('@/views/informationManage/training')
  },
  {
    path: '/swiperManage',
    name: 'SwiperManage',
    component: SwiperManage
  },
  {
    path: '/applicationFor',
    name: 'ApplicationFor',
    component: ApplicationFor
  },
  {
    path: '/messageBoard',
    name: 'MessageBoard',
    component: MessageBoard
  },
  {
    path: '/studentsManage',
    name: 'StudentsManage',
    component: StudentsManage
  },
  // 培训班合格证书管理
  {
    path: '/certificate/hgGroup',
    name: 'hgGroup',
    component: () => import('@/views/certificate/group')
  },
  // 培训班结业证书管理
  {
    path: '/certificate/jyGroup',
    name: 'jyGroup',
    component: () => import('@/views/certificate/jyGroup')
  },
  // 证书管理
  {
    path: '/certificate/detail',
    name: 'certificateDetail',
    component: () => import('@/views/certificate/detail')
  },
  // 退役军人培训
  {
    path: '/veteranManage',
    name: 'VeteranManage',
    component: () => import('@/views/veteranManage/index')
  }
]

const router = new VueRouter({
  mode: "history",
  base: window.__POWERED_BY_QIANKUN__ ? "/tvoperate" : process.env.BASE_URL,
  routes,
});

export default router;
